import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalHeader, ModalBody, Spinner } from 'reactstrap';
import { updateUserData } from '../../../../store/actions';
import { UPDATE_USER_DATA } from '../../../../store/auth/actionTypes';
import { checkIfLoading } from '../../../../store/functions';

function ChangeUserName({ modal, toggle, user }) {
    const [firstName, setFirstName] = useState(null)
    const [lastName, setLastName] = useState(null)
    const dispatch = useDispatch()
    const [t] = useTranslation()

    useEffect(() => {
        setFirstName(user?.firstName)
        setLastName(user?.lastName)
    }, [user])

    const { changeLoading } = useSelector(state => ({
        changeLoading: checkIfLoading(state, UPDATE_USER_DATA)
    }))

    const onSubmit = () => {
        dispatch(updateUserData({ firstName, lastName }, toggle))
    }

    return (
        <>
            <Modal isOpen={modal} toggle={toggle} centered={true}>
                <ModalHeader className='px-4' toggle={toggle}></ModalHeader>
                <ModalBody className='pt-1 pb-3'>
                    <h3 className='mb-3 text-center'>{t('Change personal name')}</h3>
                    <div style={{ width: "80%" }} className="m-auto">
                        <div className='mb-3'>
                            <label>{t('First Name')}</label>
                            <input type='text' value={firstName} onChange={(e) => setFirstName(e.target.value)} className='form-control custom-border' placeholder={t('Enter first name')} />
                        </div>
                        <div className='mb-3'>
                            <label>{t('Last Name')}</label>
                            <input type='text' value={lastName} onChange={(e) => setLastName(e.target.value)} className='form-control custom-border' placeholder={t('Enter last name')} />
                        </div>
                        <button type='submit' className='btn click-btn green-btn btn-block mt-2' onClick={onSubmit}>
                            {
                                changeLoading ? <Spinner size="sm" className="m-auto text-center" color="light" /> : t("Update Name")
                            }
                        </button>
                    </div>
                </ModalBody>
            </Modal>
        </>
    )
}

export default ChangeUserName